<script setup lang="ts">
import { ECMSType, ECMSPage, EHomePageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'
defineProps<{
	disableAos?: boolean
}>()
// const { isTablet_sm } = useWindowWidth()
const localePath = useLocalePath()
const { locale } = useI18n()
const banners = ref<
	| {
			[key: string]: any
	  }[]
	| undefined
>()

const { getLocaleLang } = usei18nService()

const pageSections = inject<Ref<IHomePageSectionModel[]>>('pageSections')!

if (!pageSections) {
	try {
		const type = await ApiService.fetchPageSectionByName(ECMSType.SUBPAGE, ECMSPage.HOME, EHomePageSectionType.BANNERS)
		if (type) banners.value = type?.translations.find((t) => t.language === getLocaleLang())?.content
	} catch (error) {
		console.log(error)
	}
}

watch(
	() => pageSections?.value,
	(newValue) => {
		if (newValue) {
			const section = newValue.find((section) => section.name === EHomePageSectionType.BANNERS)
			if (section) {
				banners.value = section.translations.find((t) => t.language === getLocaleLang())?.content
			}
		}
	},
	{ immediate: true, deep: true },
)
</script>

<template>
	<section v-if="banners" class="promo-banners">
		<div class="promo-banners__container">
			<div
				:data-aos="disableAos ? undefined : 'fade-up'"
				data-aos-delay="0"
				class="promo-banners__item-container promo-banners__item-container--full">
				<article class="promo-banners__item promo-banners__item--full promo-banners__item--black promo-banners__item--no-link">
					<div class="promo-banners__item-badge">{{ banners[0].name }}</div>
					<h3>
						<span class="promo-banners__item-title promo-banners__item-title-0" v-html="banners[0].text"></span>{{ ' ' }}
						<span
							class="promo-banners__item-title promo-banners__item-title-0 promo-banners__item-title--color"
							v-html="banners[0].colorText"></span>
					</h3>
					<GlobalImage
						class="promo-banners__item-background"
						alt="Promo banners arrow"
						src="promo-banners-arrow.png"
						:height="187"
						loading="eager" />
				</article>
			</div>
			<div :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="100" class="promo-banners__item-container">
				<NuxtLink :to="localePath('loyalty-program')">
					<article class="promo-banners__item">
						<div class="promo-banners__item-badge"><GlobalIcon :name="banners[1].icons?.[0]" :width="24" /></div>
						<h3 class="promo-banners__item-title promo-banners__item-title-1" v-html="banners[1].text"></h3>
						<GlobalImage class="promo-banners__item-image" alt="Promo banners cards" src="promo-banners-cards.png" :height="187" />
					</article>
				</NuxtLink>
			</div>
			<div :data-aos="disableAos ? undefined : 'fade-up'" data-aos-delay="200" class="promo-banners__item-container">
				<NuxtLink to="https://carfree.webflow.io/" target="_blank">
					<article class="promo-banners__item">
						<div>
							<div class="promo-banners__item-badge promo-banners__item-badge--white">
								<GlobalIcon :name="banners[2].icons?.[0]" :width="18" />
							</div>
							<div class="promo-banners__item-badge promo-banners__item-badge--white">
								<GlobalIcon :name="banners[2].icons?.[1]" :width="18" />
							</div>
						</div>
						<h3 class="promo-banners__item-title promo-banners__item-title-2" v-html="banners[2].text"></h3>
						<GlobalImage class="promo-banners__item-image" alt="Promo banners phones" src="promo-banners-phones.png" :height="187" />
					</article>
				</NuxtLink>
			</div>
		</div>
		<Swiper class="promo-banners__swiper" :slides-per-view="1" :space-between="10">
			<SwiperSlide>
				<article class="promo-banners__item promo-banners__item--full promo-banners__item--black">
					<div class="promo-banners__item-badge">{{ banners[0].name }}</div>
					<h3>
						<span class="promo-banners__item-title promo-banners__item-title-0" v-html="banners[0].text"></span>{{ ' ' }}
						<span
							class="promo-banners__item-title promo-banners__item-title-0 promo-banners__item-title--color"
							v-html="banners[0].colorText"></span>
					</h3>
					<GlobalImage
						class="promo-banners__item-background"
						alt="Promo banners arrow"
						src="promo-banners-arrow.png"
						loading="eager"
						:height="150" />
				</article>
			</SwiperSlide>
			<SwiperSlide>
				<NuxtLink :to="localePath('loyalty-program')">
					<article class="promo-banners__item">
						<div class="promo-banners__item-badge"><GlobalIcon :name="banners[1].icons?.[0]" :width="24" /></div>
						<h3 class="promo-banners__item-title promo-banners__item-title-1" v-html="banners[1].text"></h3>
					</article>
				</NuxtLink>
			</SwiperSlide>
			<SwiperSlide>
				<NuxtLink :to="`https://aplikacja.carfree.pl/${locale === 'pl' ? '' : 'en/home'}`" target="_blank">
					<article class="promo-banners__item">
						<div>
							<div class="promo-banners__item-badge promo-banners__item-badge--white">
								<GlobalIcon :name="banners[2].icons?.[0]" :width="18" />
							</div>
							<div class="promo-banners__item-badge promo-banners__item-badge--white">
								<GlobalIcon :name="banners[2].icons?.[1]" :width="18" />
							</div>
						</div>
						<h3 class="promo-banners__item-title promo-banners__item-title-2" v-html="banners[2].text"></h3>
					</article>
				</NuxtLink>
			</SwiperSlide>
			<PromoBannersSwiperDots />
		</Swiper>
	</section>
</template>

<style scoped lang="scss">
@import './PromoBanners.scss';
</style>
